import InvoiceDetail from '@/pages/ImportFCL/InvoiceDetail';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import {
  FC,
  useState,
  memo,
  useCallback,
  useMemo,
  MouseEventHandler,
} from 'react';
import { useTranslation } from 'react-i18next';

type DetailModalProps = {
  data: {
    descripcionFactura: string;
  };
};

const DetailModal: FC<DetailModalProps> = memo(({ data }) => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const detalle = useMemo(() => {
    return data?.descripcionFactura;
  }, [data?.descripcionFactura]);

  const { t } = useTranslation('accountStatement');

  const toggleDialog = useCallback(() => {
    setDisplayDialog((curr) => !curr);
  }, []);

  const onOpenDialogButtonClick: MouseEventHandler<SVGSVGElement> = useCallback(
    (event) => {
      event?.stopPropagation();
      toggleDialog();
    },
    [toggleDialog]
  );

  const dialogHeader = useMemo(
    () => (
      <div className="text-blue-800">
        <FontAwesomeIcon icon={faEye} style={{ marginRight: '0.5rem' }} />
        {t('viewDetail')}
      </div>
    ),
    [t]
  );
  return (
    <>
      <FontAwesomeIcon
        icon={faEye}
        onClick={onOpenDialogButtonClick}
        style={{ cursor: 'pointer' }}
      />
      {displayDialog && (
        <Dialog
          header={dialogHeader}
          visible={displayDialog}
          style={{ width: '480px' }}
          onHide={toggleDialog}
          modal
          breakpoints={{ '500px': '95vw' }}
        >
          <div className="w-full p-3">
            <InvoiceDetail data={{ detalle }} />
          </div>
        </Dialog>
      )}
    </>
  );
});

DetailModal.displayName = 'DetailModal';

export default DetailModal;
